/**
 * Analytics context: non-PII properties added to every event (Mixpanel).
 * Use in Mixpanel to filter by platform, app version, or origin.
 */

import { Platform } from 'react-native'
import Constants from 'expo-constants'
import { getAnalyticsEnvironment } from './environment.helper'

export interface AnalyticsContext {
  platform: 'web' | 'ios' | 'android'
  app_version: string
  environment: 'development' | 'production'
  /** Web only: document origin. */
  origin?: string
}

export function getAnalyticsContext(): AnalyticsContext {
  const platform = Platform.OS as 'web' | 'ios' | 'android'
  const rawVersion =
    (typeof Constants !== 'undefined' && (Constants.expoConfig as { version?: string })?.version) ??
    (typeof Constants !== 'undefined' && (Constants as { manifest?: { version?: string } }).manifest?.version) ??
    'unknown'
  const appVersion = typeof rawVersion === 'string' ? rawVersion : 'unknown'

  const context: AnalyticsContext = {
    platform,
    app_version: appVersion,
    environment: getAnalyticsEnvironment(),
  }

  if (platform === 'web' && typeof window !== 'undefined' && window.location?.origin) {
    context.origin = window.location.origin
  }

  return context
}
